import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Zap, Check, Infinity as InfinityIcon, ShieldCheck } from "lucide-react";

const PERKS = [
  "More applications every month",
  "Application tracker with detailed timeline",
  "Follow-up emails to recruiters",
  "Automatic template personalization",
];

export default function UpgradeModal() {
  const { upgradeOpen, closeUpgrade } = useAuth();
  const navigate = useNavigate();

  const viewPlans = () => {
    closeUpgrade();
    navigate("/app/pricing");
  };

  return (
    <Dialog open={upgradeOpen} onOpenChange={(o) => !o && closeUpgrade()}>
      <DialogContent
        data-testid="upgrade-modal"
        className="bg-white border border-slate-200 text-slate-900 sm:max-w-md p-0 overflow-hidden"
      >
        <div className="p-6 sm:p-8">
          <DialogTitle className="sr-only">Upgrade your plan</DialogTitle>
          <DialogDescription className="sr-only">
            Choose a plan to unlock more job applications.
          </DialogDescription>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-600 text-xs font-mono uppercase tracking-widest">
            <Zap className="w-3.5 h-3.5" /> Application limit reached
          </div>
          <h2 className="text-2xl font-bold mt-4 font-display">Upgrade to keep applying.</h2>
          <p className="text-slate-500 text-sm mt-2">
            You've used all the applications in your current plan. Pick a plan that fits your outreach needs.
          </p>

          <div className="mt-6 rounded-2xl border border-amber-500/30 bg-amber-50/60 p-5">
            <div className="flex items-center gap-2 text-amber-600 font-semibold text-sm">
              <InfinityIcon className="w-5 h-5" /> Standard &amp; Premium plans
            </div>
            <ul className="mt-4 space-y-2">
              {PERKS.map((p) => (
                <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                  <Check className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
          </div>

          <Button
            data-testid="view-plans-button"
            onClick={viewPlans}
            className="w-full mt-6 h-12 bg-amber-500 text-black hover:bg-amber-400 font-semibold text-base transition-colors"
          >
            View Plans &amp; Pricing
          </Button>
          <p className="flex items-center justify-center gap-1.5 text-xs text-slate-500 mt-3">
            <ShieldCheck className="w-3.5 h-3.5" /> Secure payment • Cancel anytime
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
